import React, { useState, useEffect, useCallback } from 'react';

const API = 'https://api.botanix.in/api';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#3AAF58', blue:'#FFFFFF', blueLight:'#FFFFFF',
 red:'#E05050', redBg:'rgba(224,80,80,.10)', redBorder:'rgba(224,80,80,.25)',
 amber:'#D4840F', amberBg:'rgba(212,132,15,.10)', amberBorder:'rgba(212,132,15,.25)',
 green:'#3AAF58',
};

const inr = n => '₹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});

const ROOM_STATUSES = ['Vacant Clean','Vacant Dirty','Occupied','Maintenance','Blocked'];
const VENUE_TYPES = ['Lawn','Banquet Hall','Conference Hall','Restaurant','Cafe/Coffee Shop','Garden','Poolside','Amphitheatre','Terrace','Other'];

const inp = { width:'100%', padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:'#F0F2FF', fontSize:14, boxSizing:'border-box', outline:'none' };
const sel = { ...inp, cursor:'pointer' };

function Modal({ title, onClose, children, maxWidth=560 }) {
 return (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.75)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
 <div style={{ background:'#1A1D27', border:'1px solid rgba(255,255,255,.14)', borderRadius:16, width:'100%', maxWidth, maxHeight:'90vh', overflow:'auto' }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'18px 22px', borderBottom:'1px solid rgba(255,255,255,.08)' }}>
 <div style={{ fontWeight:700, fontSize:15, color:'#F0F2FF' }}>{title}</div>
 <button onClick={onClose} style={{ background:'none', border:'none', color:'#606880', fontSize:20, cursor:'pointer' }}></button>
 </div>
 <div style={{ padding:22 }}>{children}</div>
 </div>
 </div>
 );
}

// ── ROOMS TAB ─────────────────────────────────────────────────────────────────
function RoomsTab() {
 const [rooms, setRooms] = useState([]);
 const [types, setTypes] = useState([]);
 const [loading, setLoading] = useState(true);
 const [showForm, setShowForm] = useState(false);
 const [editRoom, setEditRoom] = useState(null);
 const [confirmDel, setConfirmDel] = useState(null);
 const [form, setForm] = useState({ room_number:'', block_name:'', room_name:'', room_type_id:'1', floor:1, status:'Vacant Clean' });
 const set = (k,v) => setForm(p=>({...p,[k]:v}));

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const [r, t] = await Promise.all([
 fetch(`${API}/rooms`).then(x=>x.json()),
 fetch(`${API}/rooms/types`).then(x=>x.json()),
 ]);
 setRooms(Array.isArray(r)?r:[]);
 setTypes(Array.isArray(t)?t:[]);
 } catch {}
 finally { setLoading(false); }
 }, []);

 useEffect(() => { load(); }, [load]);

 const handleSave = async () => {
 const url = editRoom ? `${API}/rooms/${editRoom.id}` : `${API}/rooms`;
 const method = editRoom ? 'PUT' : 'POST';
 await fetch(url, { method, headers:{'Content-Type':'application/json'}, body:JSON.stringify(form) });
 setShowForm(false); setEditRoom(null);
 setForm({ room_number:'', block_name:'', room_name:'', room_type_id:'1', floor:1, status:'Vacant Clean' });
 load();
 };

 const handleDelete = async (id) => {
 await fetch(`${API}/rooms/${id}`, { method:'DELETE' });
 setConfirmDel(null); load();
 };

 const openEdit = (room) => {
 setEditRoom(room);
 setForm({ room_number:room.room_number, block_name:room.block_name||'', room_name:room.room_name||'', room_type_id:room.room_type_id||'1', floor:room.floor||1, status:room.status||'Vacant Clean' });
 setShowForm(true);
 };

 // Group by block
 const blocks = [...new Set(rooms.map(r=>r.block_name||'Unassigned'))];

 return (
 <div>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
 <div style={{ fontSize:13, color:C.text2 }}>{rooms.length} rooms configured</div>
 <div style={{ display:'flex', gap:8 }}>
 <button onClick={load} style={{ padding:'8px 14px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:13 }}> Refresh</button>
 <button onClick={()=>{setEditRoom(null);setForm({room_number:'',block_name:'',room_name:'',room_type_id:'1',floor:1,status:'Vacant Clean'});setShowForm(true)}}
 style={{ padding:'8px 16px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:600 }}>+ Add Room</button>
 </div>
 </div>

 {loading && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>Loading…</div>}

 {!loading && blocks.map(block => (
 <div key={block} style={{ marginBottom:24 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.accent, marginBottom:12, padding:'8px 14px', background:`${C.accent}12`, borderRadius:8, border:`1px solid ${C.accent}33` }}>
 {block}
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))', gap:10 }}>
 {rooms.filter(r=>(r.block_name||'Unassigned')===block).map(room => {
 const type = types.find(t=>t.id===room.room_type_id);
 const statusColors = { 'Vacant Clean':'#3AAF58', 'Vacant Dirty':'#D4840F', 'Occupied':'#2563A8', 'Maintenance':'#E05050', 'Blocked':'#606880' };
 const sc = statusColors[room.status] || '#606880';
 return (
 <div key={room.id} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:16 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10 }}>
 <div>
 <div style={{ fontSize:20, fontWeight:900, color:C.text }}>#{room.room_number}</div>
 {room.room_name && <div style={{ fontSize:12, color:C.accent, fontWeight:600 }}>{room.room_name}</div>}
 </div>
 <span style={{ padding:'3px 8px', borderRadius:6, fontSize:11, fontWeight:700, background:`${sc}22`, color:sc }}>{room.status}</span>
 </div>
 <div style={{ fontSize:12, color:C.text2, marginBottom:4 }}>{type?.name || 'Standard'}</div>
 <div style={{ fontSize:12, color:C.text3, marginBottom:12 }}>Floor {room.floor} · {inr(type?.base_tariff||0)}/night</div>
 <div style={{ display:'flex', gap:6 }}>
 <button onClick={()=>openEdit(room)} style={{ flex:1, padding:'5px', background:'rgba(37,99,168,.2)', border:'1px solid rgba(37,99,168,.4)', borderRadius:6, color:'#3B82F6', cursor:'pointer', fontSize:11, fontWeight:600 }}> Edit</button>
 <button onClick={()=>setConfirmDel(room)} style={{ flex:1, padding:'5px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:6, color:C.red, cursor:'pointer', fontSize:11, fontWeight:600 }}> Del</button>
 </div>
 </div>
 );
 })}
 </div>
 </div>
 ))}

 {showForm && (
 <Modal title={editRoom?`Edit Room #${editRoom.room_number}`:'Add New Room'} onClose={()=>{setShowForm(false);setEditRoom(null);}}>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Room Number * (unique)</label>
 <input style={inp} type="text" value={form.room_number} onChange={e=>set('room_number',e.target.value)} placeholder="e.g. 101, V-01" />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Block / Area Name</label>
 <input style={inp} type="text" value={form.block_name} onChange={e=>set('block_name',e.target.value)} placeholder="e.g. Petunia Cottages" />
 </div>
 <div style={{ gridColumn:'span 2' }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Room Name (optional)</label>
 <input style={inp} type="text" value={form.room_name} onChange={e=>set('room_name',e.target.value)} placeholder="e.g. The Rosewood Suite" />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Room Type</label>
 <select style={sel} value={form.room_type_id} onChange={e=>set('room_type_id',e.target.value)}>
 {types.map(t=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={t.id} value={t.id}>{t.name} — {inr(t.base_tariff)}/night</option>)}
 </select>
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Floor / Level</label>
 <input style={inp} type="number" min={0} value={form.floor} onChange={e=>set('floor',e.target.value)} />
 </div>
 <div style={{ gridColumn:'span 2' }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Status</label>
 <select style={sel} value={form.status} onChange={e=>set('status',e.target.value)}>
 {ROOM_STATUSES.map(s=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={s}>{s}</option>)}
 </select>
 </div>
 </div>
 <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:20 }}>
 <button onClick={()=>{setShowForm(false);setEditRoom(null);}} style={{ padding:'10px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={handleSave} style={{ padding:'10px 22px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>
 {editRoom?'Save Changes':'Add Room'}
 </button>
 </div>
 </Modal>
 )}

 {confirmDel && (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.7)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
 <div style={{ background:C.surface, border:`1px solid ${C.redBorder}`, borderRadius:16, padding:28, maxWidth:380, width:'90%' }}>
 <div style={{ fontSize:17, fontWeight:700, marginBottom:8, color:C.text }}>Delete Room #{confirmDel.room_number}?</div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:20 }}>This will permanently remove this room from the system.</div>
 <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
 <button onClick={()=>setConfirmDel(null)} style={{ padding:'9px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={()=>handleDelete(confirmDel.id)} style={{ padding:'9px 18px', background:C.red, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>Delete</button>
 </div>
 </div>
 </div>
 )}
 </div>
 );
}

// ── ROOM TYPES TAB ────────────────────────────────────────────────────────────
function RoomTypesTab() {
 const [types, setTypes] = useState([]);
 const [loading, setLoading] = useState(true);
 const [showForm, setShowForm] = useState(false);
 const [editType, setEditType] = useState(null);
 const [form, setForm] = useState({ name:'', base_tariff:0, occupancy:2 });
 const set = (k,v) => setForm(p=>({...p,[k]:v}));

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const r = await fetch(`${API}/rooms/types`).then(x=>x.json());
 setTypes(Array.isArray(r)?r:[]);
 } catch {}
 finally { setLoading(false); }
 }, []);

 useEffect(() => { load(); }, [load]);

 const handleSave = async () => {
 const url = editType ? `${API}/rooms/types/${editType.id}` : `${API}/rooms/types`;
 const method = editType ? 'PUT' : 'POST';
 await fetch(url, { method, headers:{'Content-Type':'application/json'}, body:JSON.stringify(form) });
 setShowForm(false); setEditType(null);
 setForm({ name:'', base_tariff:0, occupancy:2 });
 load();
 };

 return (
 <div>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
 <div style={{ fontSize:13, color:C.text2 }}>{types.length} room types</div>
 <button onClick={()=>{setEditType(null);setForm({name:'',base_tariff:0,occupancy:2});setShowForm(true)}}
 style={{ padding:'8px 16px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:600 }}>+ Add Type</button>
 </div>

 {loading && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>Loading…</div>}

 {!loading && (
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, overflow:'hidden' }}>
 <table style={{ width:'100%', borderCollapse:'collapse' }}>
 <thead>
 <tr style={{ borderBottom:`1px solid ${C.border}` }}>
 {['Room Type Name','Base Rate/Night','Max Occupancy','Actions'].map(h=>(
 <th key={h} style={{ padding:'12px 16px', fontSize:11, color:C.text2, fontWeight:600, textAlign:'left', textTransform:'uppercase', letterSpacing:'.05em' }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {types.map((t,i)=>(
 <tr key={t.id} style={{ borderBottom:'1px solid rgba(255,255,255,.04)', background:i%2===0?'transparent':'rgba(255,255,255,.02)' }}>
 <td style={{ padding:'12px 16px', fontWeight:600, color:C.text }}>{t.name}</td>
 <td style={{ padding:'12px 16px', fontSize:15, fontWeight:800, color:C.accent }}>{inr(t.base_tariff)}</td>
 <td style={{ padding:'12px 16px', color:C.text2 }}>{t.occupancy} pax</td>
 <td style={{ padding:'12px 16px' }}>
 <button onClick={()=>{setEditType(t);setForm({name:t.name,base_tariff:t.base_tariff,occupancy:t.occupancy});setShowForm(true)}}
 style={{ padding:'5px 14px', background:'rgba(37,99,168,.2)', border:'1px solid rgba(37,99,168,.4)', borderRadius:6, color:'#3B82F6', cursor:'pointer', fontSize:12, fontWeight:600 }}> Edit</button>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 )}

 {showForm && (
 <Modal title={editType?'Edit Room Type':'Add Room Type'} onClose={()=>{setShowForm(false);setEditType(null);}}>
 <div style={{ marginBottom:14 }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Room Type Name *</label>
 <input style={inp} type="text" value={form.name} onChange={e=>set('name',e.target.value)} placeholder="e.g. Luxury Villa, Cottage, Suite" />
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Base Rate per Night (₹)</label>
 <input style={inp} type="number" value={form.base_tariff} onChange={e=>set('base_tariff',e.target.value)} />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Max Occupancy (pax)</label>
 <input style={inp} type="number" min={1} value={form.occupancy} onChange={e=>set('occupancy',e.target.value)} />
 </div>
 </div>
 <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
 <button onClick={()=>{setShowForm(false);setEditType(null);}} style={{ padding:'10px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={handleSave} style={{ padding:'10px 22px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>
 {editType?'Save Changes':'Add Type'}
 </button>
 </div>
 </Modal>
 )}
 </div>
 );
}

// ── VENUES TAB ────────────────────────────────────────────────────────────────
function VenuesTab() {
 const [venues, setVenues] = useState([]);
 const [loading, setLoading] = useState(true);
 const [showForm, setShowForm] = useState(false);
 const [editVenue, setEditVenue] = useState(null);
 const [confirmDel, setConfirmDel] = useState(null);
 const [form, setForm] = useState({ name:'', venue_type:'Lawn', capacity:100, base_rate:0, gst_rate:18, description:'', is_active:true });
 const set = (k,v) => setForm(p=>({...p,[k]:v}));

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const r = await fetch(`${API}/rooms/venues`).then(x=>x.json());
 setVenues(Array.isArray(r)?r:[]);
 } catch {}
 finally { setLoading(false); }
 }, []);

 useEffect(() => { load(); }, [load]);

 const handleSave = async () => {
 const url = editVenue ? `${API}/rooms/venues/${editVenue.id}` : `${API}/rooms/venues`;
 const method = editVenue ? 'PUT' : 'POST';
 await fetch(url, { method, headers:{'Content-Type':'application/json'}, body:JSON.stringify(form) });
 setShowForm(false); setEditVenue(null);
 setForm({ name:'', venue_type:'Lawn', capacity:100, base_rate:0, gst_rate:18, description:'', is_active:true });
 load();
 };

 const handleDelete = async (id) => {
 await fetch(`${API}/rooms/venues/${id}`, { method:'DELETE' });
 setConfirmDel(null); load();
 };

 const VENUE_ICONS = { 'Lawn':'','Banquet Hall':'','Conference Hall':'','Restaurant':'','Cafe/Coffee Shop':'','Garden':'','Poolside':'','Amphitheatre':'','Terrace':'','Other':'' };

 return (
 <div>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
 <div style={{ fontSize:13, color:C.text2 }}>{venues.length} venues configured</div>
 <button onClick={()=>{setEditVenue(null);setForm({name:'',venue_type:'Lawn',capacity:100,base_rate:0,gst_rate:18,description:'',is_active:true});setShowForm(true)}}
 style={{ padding:'8px 16px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:600 }}>+ Add Venue</button>
 </div>

 {loading && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>Loading…</div>}

 {!loading && (
 <>
 {venues.length===0 && (
 <div style={{ textAlign:'center', padding:40, color:C.text2, background:C.surface, borderRadius:12 }}>
 No venues configured yet. Click + Add Venue to get started!
 </div>
 )}
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))', gap:14 }}>
 {venues.map(venue => (
 <div key={venue.id} style={{ background:C.surface, border:`1px solid ${venue.is_active!==false?C.border:C.redBorder}`, borderRadius:14, padding:18 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10 }}>
 <div style={{ fontSize:28 }}>{VENUE_ICONS[venue.venue_type]||''}</div>
 <span style={{ padding:'3px 8px', borderRadius:6, fontSize:11, fontWeight:700, background:venue.is_active!==false?C.greenBg:C.redBg, color:venue.is_active!==false?C.green:C.red }}>
 {venue.is_active!==false?'Active':'Inactive'}
 </span>
 </div>
 <div style={{ fontWeight:800, fontSize:15, color:C.text, marginBottom:4 }}>{venue.name}</div>
 <div style={{ fontSize:12, color:C.text2, marginBottom:4 }}>{venue.venue_type}</div>
 <div style={{ fontSize:12, color:C.text3, marginBottom:4 }}> {venue.capacity} pax capacity</div>
 <div style={{ fontSize:14, fontWeight:700, color:C.accent, marginBottom:8 }}>{inr(venue.base_rate)}/day</div>
 {venue.description && <div style={{ fontSize:11, color:C.text3, marginBottom:12 }}>{venue.description}</div>}
 <div style={{ display:'flex', gap:6 }}>
 <button onClick={()=>{setEditVenue(venue);setForm({name:venue.name,venue_type:venue.venue_type,capacity:venue.capacity,base_rate:venue.base_rate,gst_rate:venue.gst_rate||18,description:venue.description||'',is_active:venue.is_active!==false});setShowForm(true)}}
 style={{ flex:1, padding:'6px', background:'rgba(37,99,168,.2)', border:'1px solid rgba(37,99,168,.4)', borderRadius:6, color:'#3B82F6', cursor:'pointer', fontSize:12, fontWeight:600 }}> Edit</button>
 <button onClick={()=>setConfirmDel(venue)}
 style={{ flex:1, padding:'6px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:6, color:C.red, cursor:'pointer', fontSize:12, fontWeight:600 }}> Del</button>
 </div>
 </div>
 ))}
 </div>
 </>
 )}

 {showForm && (
 <Modal title={editVenue?`Edit — ${editVenue.name}`:'Add New Venue'} onClose={()=>{setShowForm(false);setEditVenue(null);}}>
 <div style={{ marginBottom:14 }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Venue Name *</label>
 <input style={inp} type="text" value={form.name} onChange={e=>set('name',e.target.value)} placeholder="e.g. Jungle Amphitheatre, Rose Garden" />
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Venue Type</label>
 <select style={sel} value={form.venue_type} onChange={e=>set('venue_type',e.target.value)}>
 {VENUE_TYPES.map(t=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={t}>{t}</option>)}
 </select>
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Capacity (pax)</label>
 <input style={inp} type="number" min={1} value={form.capacity} onChange={e=>set('capacity',e.target.value)} />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Base Rate per Day (₹)</label>
 <input style={inp} type="number" value={form.base_rate} onChange={e=>set('base_rate',e.target.value)} />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>GST Rate (%)</label>
 <select style={sel} value={form.gst_rate} onChange={e=>set('gst_rate',e.target.value)}>
 {[0,5,12,18,28].map(r=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={r} value={r}>{r}%</option>)}
 </select>
 </div>
 </div>
 <div style={{ marginBottom:14 }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Description</label>
 <textarea value={form.description} onChange={e=>set('description',e.target.value)} placeholder="Brief description of the venue..."
 style={{ ...inp, height:70, resize:'vertical' }} />
 </div>
 <div style={{ marginBottom:20 }}>
 <label style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer' }}>
 <input type="checkbox" checked={form.is_active} onChange={e=>set('is_active',e.target.checked)} />
 <span style={{ fontSize:13, color:C.text2 }}>Active (visible in booking form)</span>
 </label>
 </div>
 <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
 <button onClick={()=>{setShowForm(false);setEditVenue(null);}} style={{ padding:'10px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={handleSave} style={{ padding:'10px 22px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>
 {editVenue?'Save Changes':'Add Venue'}
 </button>
 </div>
 </Modal>
 )}

 {confirmDel && (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.7)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
 <div style={{ background:C.surface, border:`1px solid ${C.redBorder}`, borderRadius:16, padding:28, maxWidth:380, width:'90%' }}>
 <div style={{ fontSize:17, fontWeight:700, marginBottom:8, color:C.text }}>Delete {confirmDel.name}?</div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:20 }}>This will permanently remove this venue.</div>
 <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
 <button onClick={()=>setConfirmDel(null)} style={{ padding:'9px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={()=>handleDelete(confirmDel.id)} style={{ padding:'9px 18px', background:C.red, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>Delete</button>
 </div>
 </div>
 </div>
 )}
 </div>
 );
}

// ── MAIN COMPONENT ────────────────────────────────────────────────────────────
export default function PropertyConfig() {
 const [tab, setTab] = useState('rooms');

 const TABS = [
 { id:'rooms', label:' Rooms' },
 { id:'room_types', label:' Room Types' },
 { id:'venues', label:' Venues & Spaces' },
 ];

 return (
 <div style={{ padding:24, background:C.bg, minHeight:'100vh', color:C.text, fontFamily:'Inter,sans-serif' }}>
 <div style={{ marginBottom:24 }}>
 <div style={{ fontSize:22, fontWeight:800 }}> Property Configuration</div>
 <div style={{ fontSize:13, color:C.text2, marginTop:2 }}>Manage rooms, blocks, venues and spaces</div>
 </div>

 <div style={{ display:'flex', gap:4, marginBottom:24, background:C.surface, borderRadius:10, padding:4, width:'fit-content' }}>
 {TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{ padding:'8px 20px', borderRadius:8, border:'none', cursor:'pointer', fontSize:13, fontWeight:600, background:tab===t.id?C.accent:'transparent', color:tab===t.id?'#fff':C.text2, whiteSpace:'nowrap' }}>
 {t.label}
 </button>
 ))}
 </div>

 {tab==='rooms' && <RoomsTab />}
 {tab==='room_types' && <RoomTypesTab />}
 {tab==='venues' && <VenuesTab />}
 </div>
 );
}
